import { Badge, Button, useToggle } from '@commenda/kakashi';
import { WorkflowGeneratedDocumentModal } from '../../modals/WorkflowGeneratedDocumentModal';

type WorkflowGeneratedDocumentButtonProps = {
  workflowExecutionId: string;
  stepId: string;
};

/** Opens the preview of the document a workflow agent step generated. */
export const WorkflowGeneratedDocumentButton = ({
  workflowExecutionId,
  stepId,
}: WorkflowGeneratedDocumentButtonProps) => {
  const generatedDocumentModalVisibility = useToggle(false);

  return (
    <div className="flex items-center gap-md">
      <Button
        size="sm"
        variant="secondary"
        onClick={generatedDocumentModalVisibility.show}
      >
        View generated document
      </Button>
      <Badge variant="blue" size="sm">
        Beta
      </Badge>
      <WorkflowGeneratedDocumentModal
        isOpen={generatedDocumentModalVisibility.value}
        onClose={generatedDocumentModalVisibility.hide}
        workflowExecutionId={workflowExecutionId}
        stepId={stepId}
      />
    </div>
  );
};
